import PropTypes from 'prop-types';
import React from 'react';
import content from '../../locales/en/content.json';
import { getProfilePrefillAddress } from '../../utils/helpers';
import AddressLines from '../FormFields/AddressLines';
import PrefillConfirmationReview from './PrefillConfirmationReview';

const LABEL = content['sponsor--prefill-address-review-label'];

const SponsorAddressPrefillReview = ({ formData, ...props }) => (
  <PrefillConfirmationReview
    {...props}
    rows={[
      {
        label: LABEL,
        value: <AddressLines address={getProfilePrefillAddress(formData)} />,
      },
    ]}
  />
);

SponsorAddressPrefillReview.propTypes = {
  formData: PropTypes.object,
};

export default SponsorAddressPrefillReview;
